<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BuildingDetail from '../../../../buildings/components/BuildingDetail.vue'
import { BuildingID } from '../../../../buildings/models/building'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Business',
                route: '/(app)/settings/business/',
            },
            {
                label: 'Buildings',
                route: '/(app)/settings/buildings/',
            },
            {
                label: 'Skills',
                route: '/(app)/settings/skills/',
            },
            {
                label: 'Groups',
                route: '/(app)/settings/groups/',
            },
            {
                label: 'Shift Reasons',
                route: '/(app)/settings/shift-reasons/',
            },
        ],
    }
})

const {
  id,
} = defineProps<{
    id: BuildingID
}>()
</script>

<template>
  <BuildingDetail
    :id="id"
  />
</template>